import _import from './_import.js';

export default [
    // 登录
    {
        path: 'users/login',
        name: 'login',
        component: _import('users/login')
    },
    // 找回密码 手机
    {
        path: 'users/forgot_password',
        name: 'forgot_password',
        component: _import('users/forgot_password')
    },
    // 找回密码 邮箱
    {
        path: 'users/forgot_password_email',
        name: 'forgot_password_email',
        component: _import('users/forgot_password_email')
    },
    // 充值
    {
        path: 'users/top_up',
        name: 'top_up',
        component: _import('users/top_up'),
        meta: {
            requiresAuth: true
        }
    },
    // 用户协议
    {
        path: 'users/agreement',
        name: 'agreement',
        component: _import('register/agreement')
    },
    // 隐私政策
    {
        path: 'users/privacy_policy',
        name: 'privacy_policy',
        component: _import('register/privacy_policy')
    },
    // 注销须知
    {
        path: 'users/logout_notice',
        name: 'logout_notice',
        component: _import('member/logout_notice')
    }
];


// WEBPACK FOOTER //
// ./src/router/users.js